module.exports = __webpack_public_path__ + "static/img/slide_5_fr.b09df37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_5_fr.svg
// module id = Qdlu
// module chunks = 0